export const ARTICLE_CONTENT_TYPE = "Content::Article";
